import React, { useEffect, useState } from "react";
import { MinusCircleOutlined, PlusOutlined, UsergroupAddOutlined, UsergroupDeleteOutlined, } from "@ant-design/icons";
import { Alert, Button, Checkbox, Collapse, DatePicker, Divider, Form, Input, InputNumber, Select, Statistic} from "antd";
import axiosInstance from "../../../api/utils/axiosInstance";
import "./YPForm.css";
import moment from "moment";
import { toast } from "react-toastify";
import { ACTIVITY_TYPE, EDU_STATEMENTS } from "../../../constants";

const EDU_STRUCT = { eduName: "", eduDuration: 0,  eduPoints: 0,
  eduAuditHours: 0, eduAuditPoints: 0,
  eduAccountingHours:0, eduAccountingPoints:0,
  eduOtherHours: 0, eduOtherPoints: 0,
  eduAreaAHours: 0, eduAreaAPoints: 0};

//TODO: see if anything else needs additional validation
//TODO: see if we need additional fileds (checkboxes or something see in docs)
//TODO: logic which fields can be updated and which can't based on status
export const YPForm = ({ closeForm, setIsLoading, initialData, isApprovalAction }) => {
  const { Panel } = Collapse;
  const [form] = Form.useForm();

  const [formData, setFormData] = useState(initialData);
  const [isUpdate, setIsUpdate] = useState(initialData.id && !isApprovalAction);
  const [submitError, setSubmitError] = useState({ message: "", status: false });
  const [hiddenCheckboxes,setHiddenCheckboxes] = useState([]);

  useEffect(() => {
    const fetchData = async () => fetchNextYearPlan();

    console.log("isUpdate?", !!isUpdate);
    console.log("isApproval?", !!isApprovalAction);
    console.log("isCreate?", !isUpdate && !isApprovalAction);

    if(initialData.id){
      form.setFieldsValue(initialData);
      setHiddenCheckboxes(getHiddenCheckboxesOnInit());
    } else {
      fetchData();
    }

    //TODO:need to set hiddenCheckboxes either from initialData or from fetchData()
  }, []);

  const fetchNextYearPlan = async () => {
    setIsLoading(true);
    try {
      const res = await axiosInstance.get(`/organizer/yp?type=${initialData.type}`);
      if (res.data.id !== null) {
        console.log(res.data);
        setIsUpdate(true);
        setFormData(res.data);
        form.setFieldsValue(res.data);
      }else{
        //if this organizer didn't create a year plan for this year he will do it now, and we need to only provide the type,
        //everything else that he fills in will be saved, and backend will fetch which organizer is currenlty trying to save a year plan and for which year
        form.setFieldsValue(initialData);
      }
      setHiddenCheckboxes(getHiddenCheckboxesOnInit());
    } catch (e) {
      console.log(e.response);
      if(e.response.status === 400){
        const errMsg = e.response.data || "Dogodila se greška, molimo pokušajte ponovno"
        toast.error(errMsg,  {position: toast.POSITION.BOTTOM_RIGHT});
         closeForm();
      }
    } finally {
      setIsLoading(false);
    }
  };

  const onFinish = async (values) => {
    setIsLoading(true);
    console.log("Received values of form:", values);

    if(values.educations.length <= 0 || values.educations.filter(edu => edu === EDU_STRUCT).length > 0){
      setSubmitError({status:true, message:"Neispravan unos"});
      setIsLoading(false);
    } else {  
      try {
          const res = isUpdate ? await axiosInstance.put(`/organizer/yp`, values) : await axiosInstance.post(`/organizer/yp`, values);
          closeForm();
      } catch (e) {
        if (e.response.status === 409) {
          setSubmitError({ status: true, message: "Godišnji plan za odabranu godinu već postoji" });
          toast.error("Godišnji plan za odabranu godinu već postoji",{position:toast.POSITION.BOTTOM_RIGHT})
        }
        if(e.response.status === 400){
          const errMsg = e.response.data || "Neispravan unos, provjerite podatke i pokušajte ponovno"
          toast.error(errMsg, {position:toast.POSITION.BOTTOM_RIGHT})
        }
      } finally {
        setIsLoading(false);
      }
    }
  };

  /**
   * onValuesChange updates certain fileds usualy "*Points" because they are suppose to be copies of correponding "*Hours" values
   */
  const onValuesChange = (changedValues, allValues) => {
    changedValues.educations.map((education, index) => {
      const tempKey = (Object.keys(education))[0];
      if(tempKey.includes("Hours")){
        const dependentKey = tempKey.replace("Hours", "Points");
        form.setFieldValue(["educations", index, dependentKey], education[tempKey]);
        allValues["educations"][index][dependentKey] = education[tempKey];
        const total = calculateTotalValue(index);
        allValues["educations"][index]["eduDuration"] = total;
        allValues["educations"][index]["eduPoints"] = total;
      }

      if(tempKey === "eduFormat"){
        form.setFieldValue(["educations", index, "eduStatement1"], education[tempKey] === "WEBINAR");
        form.setFieldValue(["educations", index, "eduStatement2"], education[tempKey] === "WEBINAR");
        // let temp = undefined;
        // if(hiddenCheckboxes.filter(elem => elem.name === index).length > 0){
        //   temp = hiddenCheckboxes.map(element => {
        //     if(element.name === index){
        //       element.hidden = education[tempKey] !== "WEBINAR";
        //     }
        //     return element;
        //   })
        // }else{
        //   temp = [...hiddenCheckboxes, {name:index, hidden: education[tempKey] !== "WEBINAR"}];
        // }
        const temp = getHiddenCheckboxesOnInit();
        setHiddenCheckboxes(temp)
      }
    })
  };

  /**
   * We can use calculateTotalValue for calculating total hours as vell as total points, because bussiness logic says they should always be the same 
   */
  const calculateTotalValue = (name) => {
    const auditHours = form.getFieldValue(["educations", name, "eduAuditHours"]);
    const accountingHours = form.getFieldValue(["educations", name, "eduAccountingHours"]);
    const otherHours = form.getFieldValue(["educations", name, "eduOtherHours"]);
    const areaAHours = form.getFieldValue(["educations", name, "eduAreaAHours"]);
    const sum = (!!auditHours ? auditHours : 0.0) + (!!accountingHours ? accountingHours : 0.0) + (!!otherHours ? otherHours : 0.0); //+ (!!areaAHours ? areaAHours : 0.0); //Area A isn't apparently included in total sum, it just denotes what part of total points are area A points
    form.setFieldValue(["educations", name, "eduDuration"], sum);
    form.setFieldValue(["educations", name, "eduPoints"], sum);
    return sum;
  };

  function isDisabled() {
    return isApprovalAction || formData.approval
  }

  function isHidden(name){
    const temp = hiddenCheckboxes.filter(elem => elem.name === name);
    if(temp.length === 0){
      return true;
    }else if(temp.length === 1){
      return temp[0].hidden;
    }else{
      console.log("Ne bi trebao vratit više od jedne, ovo je edge case koji nije ispitan", temp, temp.length);
    }
  }

  function getHiddenCheckboxesOnInit(){
     const eduTemp = form.getFieldValue(["educations"]);
     const hiddenTemp = eduTemp.map((edu, index) => {
        return {name:index, hidden: edu["eduFormat"] !== "WEBINAR"};
      });
     return hiddenTemp;
  }

  const formListChildren = (fields, { add, remove }) => (
    <>
      <Collapse className="collapse-wrapper">
        {fields.map(({ key, name, ...restField }) => (
          <Panel key={key} header={form.getFieldValue(["educations", name ,"eduName"])} extra={isDisabled() ? undefined : <MinusCircleOutlined onClick={() => remove(name)} />}>
            
            <Form.Item label="Naziv edukacije" {...restField} name={[name, "eduName"]} rules={[{ required: true, message: "Ovo je obvezan podatak" }]}>
              <Input placeholder="naziv edukacije" disabled={isDisabled()} showCount maxLength={200}/>
            </Form.Item>
            
            <Form.Item {...restField} name={[name, "eduRepeat"]} valuePropName="checked"
              help="Vrijednost utječe pri dodijeli bodova edukatoru. Ako je edukator već vodio ovu edukaciju, molimo označite polje.">
              <Checkbox>Ponovljena edukacija?</Checkbox>
            </Form.Item>

            <Form.Item label="Sadržaj programa aktivnosti" {...restField} name={[name, "eduContent"]} rules={[{required: true, message:"Ovo je obvezan podatak"}]}>
              <Input.TextArea placeholder="sadržaj programa aktivnosti" disabled={isDisabled()} showCount maxLength={500} autoSize/>
            </Form.Item>

            <Form.Item label="Opseg i cilj aktivnosti" {...restField} name={[name, "eduGoal"]}>
              <Input.TextArea placeholder="opseg i clji aktivnosti" disabled={isDisabled()} showCount maxLength={500} autoSize/>
            </Form.Item>

            <Form.Item label="Ciljna skupina" {...restField} name={[name, "eduAudience"]}>
              <Input placeholder="ciljna skupina" disabled={isDisabled()} showCount maxLength={200}/>
            </Form.Item>

            <Form.Item label="Očekivani ishod učenja" {...restField} name={[name, "eduOutcome"]}>
              <Input placeholder="Očekivani ishod učenja" disabled={isDisabled()} showCount maxLength={200}/>
            </Form.Item>

            <div className="my-inline-nested-inputs">
              <Form.Item label="Način izvedbe" {...restField} name={[name, "eduFormat"]} rules={[{required: true, message:"Ovo je obvezan podatak"}]}>
                <Select placeholder="Održava li se edukacije online ili na lokaciji">
                  <Select.Option value="WEBINAR">webinar</Select.Option>
                  <Select.Option value="LIVE">uživo</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item {...restField} name={[name, "eduStatement1"]} valuePropName="checked" hidden={isHidden(name)}>
                <Checkbox>{EDU_STATEMENTS[1]}</Checkbox>
              </Form.Item>
              <Form.Item {...restField} name={[name, "eduStatement2"]} valuePropName="checked" hidden={isHidden(name)}>
                <Checkbox>{EDU_STATEMENTS[2]}</Checkbox>
              </Form.Item>
            </div>

          <div className="my-inline-nested-inputs">
            <Form.Item label="Mjesto održavanja" wrapperCol={{span: 18}} {...restField} name={[name, "eduLocation"]} rules={[{required: true, message: "Ovo je obvezan podatak"}]}>
              <Input placeholder="mjesto održavanja edukacije" />
            </Form.Item>

           <Form.Item label="Datum početka" {...restField} name={[name, "eduStartDate"]} rules={[{required: true, message:"Ovo je obvezan podatak"}]} getValueProps={(i) => ({ value: !!i ? moment(i) : undefined })}>
            <DatePicker format={"DD.MM.YYYY"}/>
           </Form.Item>

           <Form.Item label="Datum završetka" {...restField} name={[name, "eduEndDate"]} getValueProps={(i) => ({ value: !!i ? moment(i) : undefined })}
           /**
            * see https://4x.ant.design/components/form/#dependencies
            * and example under validator prop : https://4x.ant.design/components/form/#Rule
            */
              dependencies={[["educations", name, "eduStartDate"]]} 
              rules={[
                  {required: true, message:"Ovo je obvezan podatak"}, 
                  ({getFieldValue}) => ({
                    validator(_, value){
                      if(!value || moment(getFieldValue(["educations", name, "eduStartDate"])).isSameOrBefore(value, "day")){
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("Datum završetka ne može biti prije početka!"));
                    }
                  }),
                ]}
              >
            <DatePicker format={"DD.MM.YYYY"} />
           </Form.Item>
            </div>
          <Form.Item label="Specifikacija aktivnosti" {...restField} name={[name, "eduActivityType"]} rules={[{required:true, message:"Ovo je obvezan podatak"}]}>
             <Select placeholder="Odaberite specifikaciju aktivnosti iz članka 7. Pravilnika">
                  <Select.Option value={1}>{ACTIVITY_TYPE[1]}</Select.Option>
                  <Select.Option value={2}>{ACTIVITY_TYPE[2]}</Select.Option>
                  <Select.Option value={3}>{ACTIVITY_TYPE[3]}</Select.Option>
                </Select>
          </Form.Item>
          <Form.Item label="Područja aktivnosti" {...restField} name={[name, "eduActivityAreas"]} rules={[{required:true, message:"Ovo je obvezan podatak"}]}>
            <Input placeholder="Područja aktivnosti" />
          </Form.Item>
          <Divider/>
          {/**TODO: see how to make these values depend on eachother */}
            <div className="my-inline-nested-inputs">
              <label>Revizorska područja:</label>

                <Form.Item label="Sati" {...restField} name={[name, "eduAuditHours"]} >
                  <InputNumber min={0} step={0.5} disabled={isDisabled()}/>
                </Form.Item>

                <Form.Item label= "Bodovi" {...restField} name={[name, "eduAuditPoints"]} dependencies={[["educations", name, "eduAuditHours"]]}>
                  <InputNumber min={0} step={0.5} disabled/>
                </Form.Item>

              <label>Računovodstvena područja:</label>
                <Form.Item {...restField} name={[name, "eduAccountingHours"]} >
                  <InputNumber min={0} step={0.5} disabled={isDisabled()}/>
                </Form.Item>

                <Form.Item {...restField} name={[name, "eduAccountingPoints"]} dependencies={[["educations", name, "eduAccountingHours"]]} >
                  <InputNumber min={0} step={0.5} disabled/>
                </Form.Item>

                <label>Ostala područja:</label>
                <Form.Item {...restField} name={[name, "eduOtherHours"]} >
                  <InputNumber min={0} step={0.5} disabled={isDisabled()}/>
                </Form.Item>

                <Form.Item {...restField} name={[name, "eduOtherPoints"]} dependencies={[["educations", name, "eduOtherHours"]]} >
                  <InputNumber min={0} step={0.5} disabled/>
                </Form.Item>

                <label>* Ukupno aktivnosti:</label>
                <Form.Item {...restField} name={[name, "eduDuration"]}
                  dependencies={[["educations", name, "eduAuditHours"], ["educations", name, "eduAccountingHours"], ["educations", name, "eduOtherHours"], ["educations", name, "eduAreaAHours"]]}
                  rules={[
                    {required:true, message:"Ovo je obvezan podatak"},
                    ({getFieldValue}) => ({
                      validator(_){
                        if(getFieldValue(["educations", name, "eduDuration"]) !== 0){
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Neispravna vrijednost"))
                      }
                    })
                  ]}
                  >
                  <InputNumber min={0} step={0.5} disabled />
                </Form.Item>

                <Form.Item {...restField} name={[name, "eduPoints"]} 
                  dependencies={[["educations", name, "eduDuration"]]}
                  rules={[
                    {required:true, message:"Ovo je obvezan podatak"},
                     ({getFieldValue}) => ({
                      validator(_){
                        if(getFieldValue(["educations", name, "eduPoints"]) !== 0){
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Neispravna vrijednost"))
                      }
                    }) 
                  ]}>
                  <InputNumber min={0} step={0.5} disabled/>
                </Form.Item>

                <label>U tome s područja s oznakom A: </label>
                <Form.Item {...restField} name={[name, "eduAreaAHours"]}
                dependencies={[["educations", name, "eduDuration"]]}
                  rules={[
                    ({getFieldValue}) => ({
                      validator(_, value){
                        console.log(getFieldValue(["educations", name, "eduDuration"]), value,getFieldValue(["educations", name, "eduDuration"]) < value)
                        if(getFieldValue(["educations", name, "eduDuration"]) < value){
                          return Promise.reject(new Error("Ne smije premašiti ukupno"))
                        }
                        return Promise.resolve();
                      }
                    })
                  ]}
                >
                  <InputNumber min={0} step={0.5} disabled={isDisabled()}/>
                </Form.Item>

                <Form.Item {...restField} name={[name, "eduAreaAPoints"]} dependencies={[["educations", name, "eduAreaAHours"]]} >
                  <InputNumber min={0} step={0.5} disabled/>
                </Form.Item>

            </div>
          <Divider />

           <Form.Item label="Iznos kotizacije" {...restField} name={[name, "eduCost"]}>
            <InputNumber min={0} addonAfter="€"/>
           </Form.Item>

           <Form.Item label="Očekivani broj polaznika" {...restField} name={[name, "eduExpectedAttendance"]}>
              <InputNumber min={0} addonAfter={<UsergroupAddOutlined />} disabled={isDisabled()}/>
           </Form.Item>

           <Form.Item label="Minimalni broj polaznika" {...restField} name={[name, "eduMinAttendance"]} help="broj prijavljenih polaznika ispod kojeg se aktivnost neće održati">
              <InputNumber min={0} addonAfter={<UsergroupDeleteOutlined />} disabled={isDisabled()}/>
           </Form.Item>

            <Form.Item label="Rok zaprimanja prijava" {...restField} name={[name, "eduDeadline"]} getValueProps={(i) => ({ value: !!i ? moment(i) : undefined })}
           /**
            * see https://4x.ant.design/components/form/#dependencies
            * and example under validator prop : https://4x.ant.design/components/form/#Rule
            */
              dependencies={[["educations", name, "eduStartDate"]]} 
              rules={[ 
                  ({getFieldValue}) => ({
                    validator(_, value){ 
                      if(!value || moment(getFieldValue(["educations", name, "eduStartDate"])).isAfter(value, "day")){
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("Rok ne može biti poslije početka trajanja edukacije!"));
                    }
                  }),
                ]}
              >
            <DatePicker format={"DD.MM.YYYY"} />
           </Form.Item>

           <Form.Item label="Ime i prezime predavača" {...restField} name={[name, "eduEducatorName"]}>
              <Input placeholder="ime i prezime" />
            </Form.Item>

             <Form.Item label="Broj telefona" {...restField} name={[name, "eduTel"]}>
              <Input placeholder="tel." />
            </Form.Item>

             <Form.Item label="e-Mail" {...restField} name={[name, "eduMail"]}>
              <Input placeholder="e-Mail" />
            </Form.Item>
          </Panel>
        ))}
      </Collapse>
      <Form.Item>
        {!formData.approval && (
          <Button type="dashed" block onClick={() => add(EDU_STRUCT)} icon={<PlusOutlined />}>
            Dodaj edukaciju
          </Button>
        )}
      </Form.Item>
    </>
  );

  const getAlertMessage = () => {
    switch(formData.type){
      case "MAIN_YEAR_PLAN":
        return `Godišnji plan za odabranu godinu već postoji.`
      case "INDIVIDUAL_ADDITIONAL_PLAN":
        return "Dodatni pojedinačni plan za odabranu godinu već postoji."
    }
  }

  return (
    <>

      {isUpdate && <Alert  message={getAlertMessage()} description= " Mogućnost uređivanja ovisi je li odobrenje izdano ili ne." type= "warning" showIcon={true}/>}
      {submitError.status && <Alert message="Greška" description={submitError.message} type="error"/>}
      <Form name="ypForm" form={form} onValuesChange={onValuesChange} onFinish={onFinish} validateTrigger={["onChange","onSubmit"]} layout="vertical" scrollToFirstError disabled={isApprovalAction}>
        <Form.List name="educations" children={formListChildren}></Form.List>
        <Form.Item hidden name="id">
          <Input />
        </Form.Item>
        <Form.Item hidden name="year">
          <Input />
        </Form.Item>
        <Form.Item hidden name="type">
          <Input />
        </Form.Item>
        {!isApprovalAction && 
        <div className="submit-btn-wrapper">
          <Button type="primary" htmlType="submit">
            {isUpdate ? "Spremi promjene" : "Kreiraj"}
          </Button>
          <Button type="danger" onClick={closeForm}>
            Odustani
          </Button>
        </div>
        }
      </Form>
    </>
  );
};
